import {
	AsyncComboboxAutocompleteOptionPrimitive,
	AutocompleteOption,
	forwardRefWithGenerics,
} from '@aleph/shared-components';
import RedditEntityImage from 'wb-reddit/app/common/components/entityImage';

interface Option extends AsyncComboboxAutocompleteOptionPrimitive {
	userEmail?: string;
}

interface IProps<T extends Option> {
	option: T;
	onOptionClick?: (option: T) => void;
	onSelected?: () => void;
	searchQuery: string;
}

export const ComboboxAutocompleteOption = forwardRefWithGenerics(
	<T extends Option>(
		{ option, onOptionClick, onSelected }: IProps<T>,
		ref: React.ForwardedRef<HTMLDivElement>,
	) => (
		<AutocompleteOption
			ref={ref}
			image={<RedditEntityImage entity={option}/>}
			label={option.label}
			instructions={option.userEmail?.split('@')[1]}
			onClick={() => {
				onOptionClick?.(option);
				onSelected?.();
			}}
		/>
	),
);
